import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
export const GlassCard = React.forwardRef(({ className, children, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: clsx('glass snapv-premium-border snapv-premium-glass rounded-2xl p-4 sm:p-5', 'transition-all duration-300', 'hover:border-white/15 hover:shadow-[0_18px_44px_rgba(0,0,0,0.35)]', className), ...props, children: children }));
});
GlassCard.displayName = 'GlassCard';
